<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+SRC_COMMISSIONINGV2.ADD_COMPONENT_HEADER' | translate }}</span>
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="content__body">
      <div class="content__img-section">
        <img
          class="flex-1"
          src="./assets/img/commissioningv2/device-black-{{
            (commissioningService.selectedDevice$ | async).icon
          }}-qr.png"
          alt=""
        />
      </div>

      <div class="content__code-section">
        <div class="code-section__header">
          {{ '+SRC_COMMISSIONINGV2.SCAN_QR_CODE' | translate }}
        </div>
        <div class="code-section__description">
          {{
            (commissioningService.isVitotrol300E$ | async)
              ? ('+SRC_COMMISSIONINGV2.SCAN_QR_CODE_INSTRUCTION_REMOTE_CONTROLLER_300E' | translate)
              : ('+SRC_COMMISSIONINGV2.SCAN_QR_CODE_INSTRUCTION' | translate)
          }}
        </div>
        <app-banner *ngIf="isError" type="error">
          {{ '+SRC_COMMISSIONINGV2.SCAN_QR_CODE_NOT_IDENTIFIED' | translate }}
        </app-banner>

        <div class="code-section__wrapper">
          <div class="qr-code__wrapper">
            <button
              gtm="onNextStep"
              gtmAction="Type Code Manualy"
              gtmCategory="codeModal"
              class="qr-code__btn"
              mat-stroked-button
              color="primary"
              (click)="openCodeForm()"
            >
              {{ '+SRC_COMMISSIONINGV2.TYPE_CODE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <button
      data-at-code-modal-back-btn
      gtm="onPreviousStep"
      gtmAction="Previous step"
      gtmCategory="addRoomModal"
      mat-stroked-button
      color="primary"
      (click)="navigateBack()"
    >
      {{ 'GENERAL.BUTTON.BACK' | translate }}
    </button>
    <button
      gtm="onNextStep"
      gtmAction="Scan QR code"
      gtmCategory="codeModal"
      data-at-code-modal-next-btn
      mat-raised-button
      color="primary"
      (click)="openScanner()"
    >
      {{ 'GENERAL.BUTTON.SCAN' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
